// Golf 8 : textes de l'application pour le check-in quotidien et le cercle familial. Tutoiement,
// ton calme ; jamais une alarme. POORT: moedertaalreview vóór livegang.
export const appCareFr = {
    nav: 'Check-in et cercle',
    notForRelative: 'Cette page n’est pas disponible pour les proches qui suivent.',
    account: 'Compte',
    viaBoard: '(oui dit sur le tableau)',
    viaApp: '(oui dit dans l’application)',
    subjectLabel: 'Qui appuie chaque jour ?',
    removed: '{label} a été retiré du cercle.',
    left: 'Tu as quitté le cercle.',
    comingSoon: 'Le check-in quotidien et le cercle familial arrivent bientôt. Le tableau, l’agenda et les rappels fonctionnent déjà.',
    wizardSeniorLine: 'La famille suivra plus tard ? Active-le dans Réglages, Check-in et cercle.',
    setupSaved: 'Le check-in est prêt.',
    circleOn: 'Laisser la famille suivre',
    personRights: 'Droits de {label}',
    managerSeesAll: 'Gère le tableau et voit tout.',
    noReachSave: 'Tu pourras l’activer quand quelqu’un pourra recevoir un signal.',
    consentLaterWizard: 'Le check-in ne commence que quand {name} dit oui sur le tableau.',
    title: 'Check-in et cercle',
    settingsBody: 'Un grand bouton « Tout va bien » sur le tableau, et la famille qui suit à distance.',
    widgetTitle: 'Check-in quotidien',
    setupTitle: 'Comment vous restez en contact',
    setupIntro: 'Chaque jour, {name} appuie une fois sur « Tout va bien ». Sinon, la famille reçoit un signal calme.',
    whoUsesBoard: 'Qui utilise le tableau ?',
    boardSelf: 'Moi',
    boardOther: 'Quelqu’un d’autre',
    otherName: 'Comment s’appelle cette personne ?',
    otherNamePlaceholder: 'Par exemple Maman',
    ownerHidden: 'Tu n’apparais pas sur le tableau.',
    capacityQ: '{name} peut-il ou elle décider seul(e) ?',
    capacityYes: 'Oui',
    capacityNoButton: 'Non',
    capacityNo: 'Alors nous ne pouvons pas encore activer le check-in. {name} doit pouvoir dire oui. Le tableau et l’agenda fonctionnent normalement.',
    checkInToggle: 'Check-in quotidien',
    deadline: 'Au plus tard à',
    days: 'Ces jours-là',
    dayNames: ['lun', 'mar', 'mer', 'jeu', 'ven', 'sam', 'dim'],
    grace: 'Signal après',
    graceMin: '{n} minutes',
    whoFollows: 'Qui suit ?',
    whoFollowsHint: 'Chacun reçoit un e-mail. Ensuite, {name} dit sur le tableau si c’est d’accord.',
    inviteEmail: 'Adresse e-mail',
    inviteLabel: 'Comment {name} t’appelle-t-il ou elle ?',
    inviteLabelOther: 'Comment {name} appelle-t-il ou elle cette personne ?',
    addPerson: 'Quelqu’un d’autre',
    rightAlerts: 'Signal si « Tout va bien » n’arrive pas',
    rightAgenda: 'Voir l’agenda (sans les rendez-vous privés)',
    invite: 'Inviter',
    invited: 'Invitation envoyée à {email}',
    later: 'Plus tard',
    disclaimerTitle: 'Pas un service d’alarme',
    disclaimerBody: 'Le check-in est un signal calme, pas une alarme. Il ne détecte pas les chutes et n’appelle pas les secours. Pas de message ne veut pas toujours dire que tout va bien. En cas d’urgence, appelle le 112.',
    disclaimerCheck: 'Je comprends que ce n’est pas un service d’alarme.',
    selfConsentNow: 'Comme tu utilises toi-même le tableau, nous te demandons ton oui ici.',
    otherConsentLater: 'La première fois, le tableau demande à {name} si c’est d’accord. D’ici là, aucun signal.',
    finish: 'Terminé',
    save: 'Enregistrer',
    saved: 'Enregistré',
    cancel: 'Annuler',
    enable: 'Activer',
    disable: 'Désactiver',
    reachTitle: 'Qui reçoit un signal ?',
    reachOk: '{n} sur {m} reçoivent maintenant un signal.',
    reachNone: 'Personne ne reçoit de signal pour le moment.',
    reachNeedsInstall: '{label} doit d’abord ajouter AMUMIN à l’écran d’accueil.',
    reachNoPush: '{label} n’a pas encore activé les notifications.',
    reachFailed: 'Le dernier signal à {label} n’est pas arrivé.',
    reachEnableFirst: 'Active d’abord les notifications sur ton téléphone. Ensuite tu pourras activer le check-in.',
    noReachInvited: 'Personne ne peut encore recevoir de signal : {names} doit encore accepter l’invitation. Ensuite tu pourras activer le check-in.',
    noReachYourYes: 'Personne ne peut encore recevoir de signal : {names} attend ton oui (en haut d’Aujourd’hui). Ensuite tu pourras activer le check-in.',
    noReachTheirYes: 'Personne ne peut encore recevoir de signal : {names} attend le oui de {name} sur le tableau.',
    noReachPush: 'Personne ne peut encore recevoir de signal : {names} doit d’abord activer les notifications. Ensuite tu pourras activer le check-in.',
    noReachSelf: 'Personne ne peut encore recevoir de signal. Invite quelqu’un à suivre ; cette personne accepte l’invitation et active les notifications.',
    pendingOnTitle: 'Le check-in est encore désactivé',
    pendingOnReady: 'Quelqu’un peut maintenant recevoir un signal ({n} sur {m}). Tu peux activer le check-in.',
    pendingOnButton: 'Activer le check-in',
    pendingOnDone: 'Le check-in est activé.',
    pushEnable: 'Activer les notifications sur ce téléphone pour la maison de {name}',
    pushOpen: 'Régler les notifications',
    iosInstall: 'Sur iPhone : appuie sur Partager, puis « Sur l’écran d’accueil », et ouvre AMUMIN depuis là.',
    waitConsent: 'En attente du oui de {name} sur le tableau.',
    declined: '{name} préfère ne pas. Tu pourras redemander après le {date}.',
    askAgain: 'Redemander sur le tableau',
    activeSince: 'Actif depuis le {date}',
    stoppedGone: '{name} ne fait plus partie de ce foyer. Le check-in est désactivé.',
    stoppedBySelf: '{name} a désactivé le check-in. Tu peux redemander.',
    orphanTitle: 'Tu ne fais plus partie d’aucun foyer',
    orphanBody: 'Tu ne suis plus personne et tu n’es membre d’aucun foyer. Ton compte reste jusqu’à ce que tu le supprimes toi-même.',
    orphanAccount: 'Compte',
    orphanLogout: 'Se déconnecter',
    stateDone: '{name} a appuyé sur « Tout va bien » à {time}.',
    stateWaiting: 'Pas encore. Au plus tard {time}.',
    stateDue: 'Pas encore. {name} peut encore appuyer.',
    stateMissing: 'Pas encore de « Tout va bien » de {name} aujourd’hui.',
    stateMissingEarlier: 'Hier ({date}), aucun « Tout va bien » n’est venu de {name}.',
    stateBoardOffline: 'Le tableau est hors ligne depuis {time}, {name} ne peut peut-être pas appuyer.',
    stateNoBoard: 'Aucun tableau n’est associé.',
    stateResolved: 'Tout va bien finalement : {name} a appuyé à {time}.',
    stateResolvedOffline: 'Tout va bien finalement : {name} a appuyé à {time} (le tableau était hors ligne).',
    stateResolvedManual: '{label} : tout va bien ({time}).',
    stateNotChecked: 'Aujourd’hui, nous n’avons pas pu vérifier (panne chez AMUMIN). Prends toi-même des nouvelles.',
    stateDegraded: 'Nous ne vérifions pas pour le moment (panne).',
    statePaused: 'Pause jusqu’au {date} inclus (mise par {label}).',
    stateOff: 'Le check-in est désactivé.',
    stateNotToday: 'Pas de check-in aujourd’hui.',
    stateConsentNeeded: 'En attente du oui de {name} sur le tableau.',
    stateDeclined: '{name} préfère ne pas.',
    silenceNote: 'Pas de message ne veut pas toujours dire que tout va bien.',
    emergencyNote: 'Pas un service d’alarme. En cas d’urgence : 112.',
    ack: 'J’appelle',
    acked: '{label} appelle ({time})',
    ackStale: '{label} appelle depuis {time}, pas encore confirmé.',
    resolve: 'Tout va bien',
    tzNote: '(heure chez {name})',
    history: '{n} derniers jours',
    historyKinds: {
        done: 'Tout va bien',
        late: 'Appuyé plus tard',
        missing: 'Pas d’appui',
        paused: 'Pause',
        not_checked: 'Non vérifié',
        off: 'Pas de check-in',
    },
    pauses: 'Pauses',
    pauseAdd: 'Ajouter une pause',
    pauseFrom: 'Du',
    pauseTo: 'Au (inclus)',
    pauseMax: 'Au maximum {n} jours. Absent plus longtemps ? Désactive alors le check-in.',
    inviteInUse: 'Cette adresse a déjà une invitation comme colocataire. Retire-la d’abord.',
    pauseLimit: 'Une personne qui suit peut mettre au maximum {n} jours de pause au total, et pas plus de {n} jours à l’avance.',
    someone: 'quelqu’un',
    pauseHint: 'Par exemple en vacances ou chez quelqu’un. Nous ne gardons aucune raison.',
    pauseLine: 'Du {from} au {to} inclus (mise par {label})',
    pauseStop: 'Arrêter la pause',
    pauseNone: 'Aucune pause prévue.',
    offlineTitle: 'Et si le tableau est hors ligne ?',
    offlineHelp: 'Sans connexion, l’appui est envoyé plus tard. {name} peut aussi utiliser l’application sur le téléphone.',
    outageTitle: 'Et si AMUMIN a une panne ?',
    outageHelp: 'En cas de panne d’AMUMIN, tu verras ici « Non vérifié aujourd’hui ». Pas de message n’est pas une preuve que tout va bien.',
    circleTitle: 'Cercle',
    circleEmpty: 'Personne ne suit encore.',
    circleStatusInvited: 'Invité',
    circleStatusPending: 'En attente du oui de {name}',
    circleStatusActive: 'Actif',
    circleStatusDeclined: 'Préfère ne pas',
    roleRelative: 'Proche',
    roleManager: 'Gestionnaire',
    remove: 'Retirer du cercle',
    removeConfirm: 'Retirer {label} du cercle ? {label} ne verra plus rien immédiatement.',
    removePauseNote: '{label} a mis une pause jusqu’au {date}. Cette pause s’arrête si tu retires {label}.',
    leave: 'Quitter le cercle',
    leaveConfirm: 'Quitter le cercle ? Tu ne verras plus rien de la maison de {name}.',
    resend: 'Renvoyer',
    rightsNeedYes: 'Plus de droits ? Le tableau demande d’abord un oui à {name}.',
    newWatcher: '{label} suit maintenant : {rights}.',
    inviteSomeone: 'Inviter quelqu’un',
    seniorNoCircle: 'Il n’y a encore personne qui peut recevoir un signal.',
    switchToCare: 'Devient « À la maison avec la famille qui suit »',
    selfButton: 'Tout va bien',
    selfConsentIntro: 'Lis ceci calmement. Tu décides.',
    selfWithdraw: 'Arrêter le check-in',
    approveTitle: '{label} aimerait suivre',
    approveYes: 'Oui, c’est d’accord',
    approveNo: 'Je préfère ne pas',
    myCircleTitle: 'Mon cercle',
    myRights: 'Ce que tu vois de la maison de {name}',
    myRightsNone: 'Tu ne vois encore rien : {name} dit d’abord oui sur le tableau.',
    pushCheckIn: 'Check-in quotidien',
    pushCheckInQuiet: 'Aussi pendant les heures calmes (sinon le signal arrive après)',
    inviteTitle: 'Invitation à suivre',
    inviteBody: '{inviter} t’invite à suivre {household}, en tant que « {label} ».',
    inviteRights: 'Tu peux :',
    inviteAcceptExisting: 'Accepter',
    inviteLoginFirst: 'Connecte-toi d’abord avec {email}, puis rouvre le lien.',
    inviteAcceptNew: 'Créer un compte et accepter',
    invitePassword: 'Choisis un mot de passe',
    inviteWrongEmail: 'Cette invitation est pour une autre adresse e-mail.',
    inviteInvalid: 'Cette invitation est invalide ou a expiré.',
    inviteAccepted: 'C’est fait. Le tableau demande d’abord si c’est d’accord. Ensuite tu le verras ici.',
    inviteToApp: 'Vers l’application',
    notEmergencyShort: 'Ce n’est pas un service d’alarme.',
    errorGeneric: 'Cela n’a pas marché. Réessaie.',
};
//# sourceMappingURL=careApp.fr.js.map